import EventApi from '../../../../../../../api/EventsApi';
import {VideoSeat} from './video_placeholders/VideoSeat';
import {TableController} from '../../../../controllers/silent/TableController';
import {Stack} from './stacks/Stack';
import {GameState} from '../../../../../../../../types/game-state';
import MessageHelper from '../../../../../../../helpers/MessageHelper';
import {StaticData} from '../../../../data/StaticData';
import {Sprite} from 'pixi.js';
import TState = GameState.TState;

export default class VideoPlaceholders extends Sprite
{
    private seats: VideoSeat[] = [];
    //private playersData: Record<string, GameState.TPlayerData> | undefined;
    private addRemoteSeatBindThis: (e: Event) => void;
    private addLocalSeatBindThis: (e: Event) => void;
    private exitSeatBindThis: (e: Event) => void;
    private awaitingIds: string[] = [];
    private gameState: TState | undefined;

    constructor() {
        super();

        this.addRemoteSeatBindThis = this.addRemoteSeat.bind(this);
        this.addLocalSeatBindThis = this.addLocalSeat.bind(this);
        this.exitSeatBindThis = this.exitSeat.bind(this);

        this.initEvents();
        this.init();
    }

    /**
     * Удалить видео, отвязать слушатели событий
     */
    public destroy(): void {
        this.unbindEvents();
        this.removeChild(...this.seats);
        this.seats = [];

        delete this.addRemoteSeatBindThis;
        delete this.addLocalSeatBindThis;
        delete this.exitSeatBindThis;
        super.destroy({children: true});
    }

    public init(): void {
        const videos = document.querySelectorAll('#seatsHolder video');
        if (!videos.length) {
            return;
        }
        videos.forEach((video, index) => {
            console.log('videosHTML', index, video.id);
            let seatId = index == 0 ? StaticData.playerId : video.parentElement!.parentElement!.dataset.endpointId!;
            if (this.awaitingIds.includes(seatId)) {
                return;
            }
            this.awaitingIds.push(seatId);
            setTimeout(() => {
                let my: boolean = index == 0;
                let playerId: string = my ? StaticData.playerId : video.parentElement!.parentElement!.dataset.endpointId!;
                console.log('from here', playerId);
                this.createVideoSeat(my, playerId);

            }, 1000);
        });

    }

    updateColors() {
        this.children.forEach(child => (child as VideoSeat).updateColor());
    }

    setPlayersData(gameState:TState): void {
        this.gameState = gameState;
        this.seats.forEach((seat: VideoSeat) => {
            console.log('playersData[seat.seatId]', seat.playerId, this.gameState!.playersData[seat.playerId]);
            seat.parsePlayerData(this.gameState!.playersData[seat.playerId]);
            seat.setActive(!!gameState?.automation?.playersMap?.[seat.playerId]?.master);
        });
    }

    private initEvents(): void {
        EventApi.addEventListener(EventApi.REMOTE_MEDIA_ADDED, this.addRemoteSeatBindThis);
        EventApi.addEventListener(EventApi.LOCAL_TRACK_PUBLISHED, this.addLocalSeatBindThis);
        EventApi.addEventListener(EventApi.EXIT_SEAT, this.exitSeatBindThis);
    }

    private unbindEvents(): void {
        EventApi.removeEventListener(EventApi.REMOTE_MEDIA_ADDED, this.addRemoteSeatBindThis);
        EventApi.removeEventListener(EventApi.LOCAL_TRACK_PUBLISHED, this.addLocalSeatBindThis);
        EventApi.removeEventListener(EventApi.EXIT_SEAT, this.exitSeatBindThis);
    }

    /**
     * Удалить видео по id
     * @param id
     * @private
     */
    private deleteVideoById(seatId: string): void {
        let deletingSeat: VideoSeat | undefined = this.seats.find(seat => seat.playerId === seatId);
        if (!deletingSeat) {
            return;
        }

        this.seats.splice(this.seats.indexOf(deletingSeat), 1);
        deletingSeat.destroy();
        this.removeChild(deletingSeat);
    }

    /**
     * Создать сит на столе
     * @param video
     * @param index
     * @param id
     * @private
     */
    private createVideoSeat(my: boolean, playerId: string): void {
        if (this.seats.find(seat => seat.playerId === playerId)) {
            this.checkPlayersData();
            return;
        }
        console.log('creating with id:', playerId, my);
        let videoSeat: VideoSeat = new VideoSeat(playerId, my);
        this.addChild(videoSeat);
        this.seats.push(videoSeat);
        let stack: Stack | undefined = TableController.table.tableObjects?.stacks.stacks.find(stack => stack.activeData.cards.getLast().width == 117);
        if (stack) {
            videoSeat.position.set(stack.x, stack.y);
        }
        this.awaitingIds.splice(this.awaitingIds.indexOf(playerId), 1);
        this.checkPlayersData();
    }

    /**
     * Добавить локальный сит
     * @private
     */
    private addLocalSeat(e: any): void {
        e;
        if (this.awaitingIds.includes(StaticData.playerId)) {
            return;
        }
        this.awaitingIds.push(StaticData.playerId);
        setTimeout(() => {
            this.createVideoSeat(true, StaticData.playerId);
        }, 1000);
    }

    private checkPlayersData(): void {
        if (this.gameState) {
            this.setPlayersData(this.gameState);
        } else {
            MessageHelper.getState();
        }
    }

    /**
     * Удаление сита со стола
     */
    private exitSeat(e: any): void {
        const id: string = e.detail.seatId;
        this.deleteVideoById(id);
    }

    /**
     * Добавление удаленного сита на стол
     */
    private addRemoteSeat(e: any): void {
        const playerId: string = e.detail;
        if (this.awaitingIds.includes(playerId)) {
            return;
        }
        this.awaitingIds.push(playerId);
        setTimeout(() => {
            this.createVideoSeat(false, playerId);
        }, 1000);
    }
}
